const userLocationIconOptions: woosmap.map.Icon = {
    url: "https://images.woosmap.com/user-position.png",
    scaledSize: {
        height: 32,
        width: 32,
    },
    anchor: {x: 16, y: 16}
}

const storeIconOptions: woosmap.map.Icon = {
    url: "https://images.woosmap.com/starbucks-marker.svg",
    scaledSize: {
        height: 36,
        width: 30,
    },
}
const mapPaddings: { [key: string]: woosmap.map.Padding } = {
    full: {left: 50, right: 50, top: 80, bottom: 50},
};


const mapOptions: woosmap.map.MapOptions = {
    center: {lat: 46.2, lng: 3.2},
    zoom: 6,
    styles: [
        {
            featureType: "point_of_interest",
            elementType: "all",
            stylers: [
                {
                    visibility: "on",
                },
            ],
        },
    ],
    gestureHandling: "cooperative",
};


export default {
    mapOptions: mapOptions,
    userLocationIconOptions: userLocationIconOptions,
    storeIconOptions: storeIconOptions,
    mapPaddings: mapPaddings,
}